import { Component } from 'react';

/** Components */
import KeypadButton from './KeypadButton';

class MathModeKey extends Component {
  state = {
    mathRoman: false,
  };

  handleClick = () => {
    this.setState({
      mathRoman: !this.state.mathRoman,
    });
  };

  render() {
    return <KeypadButton label="T" onClick={this.handleClick} />;
  }
}

export default MathModeKey;
